import { render, staticRenderFns } from "./BackendForm.vue?vue&type=template&id=2417e680"
import script from "./BackendForm.vue?vue&type=script&lang=js"
export * from "./BackendForm.vue?vue&type=script&lang=js"
import style0 from "./BackendForm.vue?vue&type=style&index=0&id=2417e680&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports